<template>
    <div
        class="list-client__container"
        v-if="canChange"
    >
        <div class="pagination">
            <div
                    class="pagination__item"
                    v-for="pageNum in pageCount"
                    :key="pageNum"
                    :class="{'active': (pageNum - 1) === page}"
                    @click="changePage(pageNum)"
            >
                {{pageNum}}
            </div>
        </div>
        <table-settings
                :labels="labels"
                :rows="fileList"
                :isPreloader="isPreloader()"
                :columnSettings="columnSettings"
        />

    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import serviceApi from "../../services/serviceApi";
import schemeApi from '../../schemes/schemeApi';
import serviceAuth from "../../services/serviceAuth";
import TableSettings from "../../components/Tables/TableSettings";
import schemeSettingsHistory from '../../schemes/schemeSettingsHistory';
let {
    routeHistory,
    routeClientManagers
} = schemeApi;
let {columnSettings, labels, statuses} = schemeSettingsHistory;
export default {
    name: 'ViewSettingsHistory',
    components: {
        TableSettings
    },
    /**
     * Данные компонента
     * @property {array} fileList - список клиентов
     * @property {array} managers - список менеджеров
     * @property {boolean} isGettingList флаг получения списка клиентов
     * @property {boolean} canChange флаг разрешения на возможность редактировать
     */
    data: () => ({
        fileList: [],
        isGettingList: false,
        canChange: false,
        page: 0,
        pageCount: 0,
        managers: {},
        columnSettings: columnSettings,
        labels: labels,
      yOffset: null
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        }),
    },
    watch: {
        page(){
            this.getFiles();
        }
    },
    mounted() {
        // устанавливаем текущее название страницы
        this.setCurrentViewName("История загрузок");
        // получаем право на редактирование
        this.canChange = serviceAuth.checkPermission(this.activeProjectId, 'change_settings');
        if(this.canChange){
            this.getManagers(() => {
                this.getFiles();
            });

        }
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ]),
        /**
         * запрос на списка менеджеров
         * @async
         */
        async getFiles() {
            this.isGettingList = true;
            try {
                let {data = {}} = await serviceApi.get(routeHistory + "?page=" + this.page);
                let {items = [], pageCount = 0} = data;
                this.fileList =[];
                this.pageCount = pageCount;
                items.forEach((item) => {
                    const {user_id: userId, uploader_id: uploaderId, name, status, created_at: createdAt, directory} = item;
                    this.fileList.push({
                        user_id: this.managers[userId],
                        uploader_id: this.managers[uploaderId],
                        name,
                        created_at: (new Date(createdAt)).toLocaleString("ru"),
                        status: statuses[status],
                        directory: process.env.VUE_APP_BACKEND_HOST + "/" + directory
                    });
                });
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                else if (error.response.data.data.message === 'Доступ запрещен') {
                    alert('Доступ запрещен');
                    this.$router.push({name: 'analyticsSummary'});
                }
            }
            this.isGettingList = false;
        },
        /**
         * запрос на списка менеджеров
         * @async
         */
        async getManagers(actionAfter = () => {}) {
            this.isGettingList = true;
            try {
                let {data = {}} = await serviceApi.post(routeClientManagers);
                this.managers = data.list;
                actionAfter();
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                else if (error.response.data.data.message === 'Доступ запрещен') {
                    alert('Доступ запрещен');
                    this.$router.push({name: 'analyticsSummary'});
                }
            }
            this.isGettingList = false;
        },
        isPreloader(){
            return this.isGettingList;
        },
        changePage(pageNum){
            this.page = pageNum - 1;
        }
    }
}
</script>

<style lang="scss" scoped>
    .list-client__container {
        margin-top: 10px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
        -webkit-box-flex: 1;
    }
    .list-client__item{
        border-radius: 10px;
        border: none;
        background: none;
        color: #2686e6;
        outline: none;
        padding: 10px;
    }
    .list-client__item_pointer{
        cursor: pointer;
    }
    .list-client__item_active{
        background: #dcdcdc;
    }

    .pagination{
        margin: 10px 0;
        display: flex;
        &__item{
            padding: 5px;
            text-decoration: underline;
            cursor: pointer;
        }

        .active{
            text-decoration: none;
        }

    }
</style>